import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';
import { combineLatest, filter, map } from 'rxjs';
import { AuthService } from './core/services/auth';
import { SharedService } from './core/services/shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  router = inject(Router);
  matDialog = inject(MatDialog);
  authService = inject(AuthService);
  sharedService = inject(SharedService);

  isAuthenticated$ = this.authService.isAuthenticated$;

  isSidenavOpened$ = this.sharedService.isSidenavOpened$;

  hasSidenav$ = combineLatest([
    this.isAuthenticated$,
    this.isSidenavOpened$,
  ]).pipe(
    map(
      ([isAuthenticated, isSidenavOpened]) => isAuthenticated && isSidenavOpened
    )
  );

  mainStyles$ = this.hasSidenav$.pipe(
    map((hasSidenav) => ({
      'min-height': hasSidenav ? 'calc(100% - 65px)' : '100%',
    }))
  );

  closeMatDialogsOnNavigation$ = this.router.events
    .pipe(filter((event) => event instanceof NavigationStart))
    .subscribe(() => {
      this.matDialog.openDialogs.forEach((d) => d.close());
    });
}
